import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";

export function Breadcrumbs() {
	const location = useLocation();
	const crumbs = location.pathname.split("/").filter((x) => !!x);

	if (crumbs.length === 1) {
		return null;
	}

	const pathSegs: string[] = [];

	return (
		<div className="flex items-center gap-1">
			<p className="text-neutral-500 text-sm">/</p>
			{crumbs.map((crumb, i) => {
				const link = `${pathSegs.join("/")}/${crumb}`;
				pathSegs.push(crumb);
				const isLast = i === crumbs.length - 1;

				return (
					<span key={crumb} className="contents">
						<Button variant="link" className="p-0">
							{isLast ? (
								<p>{crumb}</p>
							) : (
								<Link
									to={link.startsWith("/") ? link : `/${link}`}
									viewTransition
								>
									{crumb}
								</Link>
							)}
						</Button>
						{!isLast && <p className="text-neutral-500 text-sm">/</p>}
					</span>
				);
			})}
		</div>
	);
}
